<template>
    <div class="pa-2" >
        <div class="d-flex justify-center">
                
            <v-card
                width="640"
                flat
                outlined
            >
                <v-data-table
                    :headers="headers"
                    :items="table2Records"
                    dense                    
                    fixed-header
                    height="250"
                    disable-pagination
                    hide-default-footer                        
                >
                    <template v-slot:item="{ item }">
                            <SubjectRow
                            v-bind:item="item"
                            v-bind:formLevel="formLevel"
                            v-bind:term="currentTerm"
                            v-bind:maxCourse="maxCourse"
                            v-bind:maxExam="maxExam"
                            v-on:update-average="getAverage"
                        ></SubjectRow>                       
                    </template>
                    
                </v-data-table>
            </v-card >

            <!-- Subjects -->
            <v-card
                width="86"
                flat
                outlined
            >
                <v-data-table
                    :headers="headersSubjects"
                    :items="studentSubjects"
                    dense
                    fixed-header
                    height="280"
                    disable-pagination
                    hide-default-footer
                >
                    <template v-slot:item="{ item }">
                        <tr>
                            <td style="max-width: 1px; white-space: nowrap; overflow:hidden; text-overflow: ellipsis; ">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <span
                                            v-bind="attrs"
                                            v-on="on"
                                            :class="classStudentSubjects(item)"
                                        > 
                                            {{ item.abbr}} 
                                        </span>
                                    </template>
                                    <span>{{ item.title}}</span>
                                </v-tooltip>                                   
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-card>
                   
        </div>

        <div class="mt-4 d-flex px-2">
            <div>

                <v-card flat width="620" class="d-flex justify-space-between">
                    
                    <div class="d-flex mb-2 justify-center">
                        <v-btn                        
                            outlined
                            small
                            color="primary"
                            @click="classMarkSheet"
                            width="140"
                            
                        >
                            <span style="font-size: 0.6rem" >Class Mark Sheet</span>
                        </v-btn>
                    </div>
                    
                    <div class="d-flex mb-2 justify-center">
                        <v-btn                        
                            outlined
                            small
                            color="primary"
                            @click="rankSheet"
                            width="100"
                        >
                            <span style="font-size: 0.6rem">Rank Sheet</span>
                        </v-btn>
                    </div>

                    <div class="d-flex mb-2 justify-center">
                        <v-btn                        
                            outlined
                            small
                            color="primary"
                            @click="enterMarks"
                            width="100"
                            :disabled="!editTermReports"
                        >
                            <span style="font-size: 0.6rem">Enter Marks</span>
                        </v-btn>
                    </div>

                    <div class="d-flex mb-2 justify-center">
                        <v-btn                        
                            outlined
                            small
                            color="red"
                            width="100"
                            @click="closeEditViewTermReports"
                        >
                            <span style="font-size: 0.6rem">Close Form</span>
                        </v-btn>
                    </div>
    
                </v-card>    
                
                <v-card flat width="620" class="d-flex justify-space-between">
                    <div class="d-flex justify-space-between">
                        <v-btn                        
                            outlined
                            small
                            color="primary"
                            @click="searchStudent"
                            width="64"
                            class="mr-3"
                        >
                            <span style="font-size: 0.6rem">Search</span>
                        </v-btn>

                        <v-btn                        
                            outlined
                            small
                            color="primary"
                            @click="nextClass"
                            width="64"
                        >
                            <div class="d-flex flex-column">
                            <span style="font-size: 0.6rem">Next</span>
                            <span style="font-size: 0.6rem">Class</span>
                            </div>
                        </v-btn>
                    </div>

                    <div class="d-flex justify-center pt-0">
                        <v-btn                        
                            outlined
                            small
                            color="primary"
                            @click="displayReportCard"
                            width="100"
                        >
                            <span style="font-size: 0.6rem">Print One</span>
                        </v-btn>
                    </div>

                    <div class="d-flex justify-center pt-0">
                        <v-btn                        
                            outlined
                            small
                            color="primary"
                            @click="displayReportCardsClass"
                            width="100"
                        >
                            <span style="font-size: 0.6rem">Print Class</span>
                        </v-btn>
                    </div>

                    <!-- <div class="d-flex justify-center pt-0">
                        <v-btn
                            :disabled="!admin"                        
                            outlined
                            small
                            width="100"
                            @click="showMoreOptions"
                        >
                            <span style="font-size: 0.6rem">More Options</span>
                        </v-btn>
                    </div> -->

                    <v-btn
                        outlined
                        small
                        width="100"
                        @click="displayAcademicHistory"
                    >
                        <span style="font-size: 0.5rem">Academic History</span>
                    </v-btn>

                        
                </v-card> 
            </div>
                
            <div class="">
                
            </div>
                
        </div>

        <div class="mt-6 d-flex px-2 pr">

            <v-card flat width="620" class="d-flex justify-end px-3">
                <v-card
                    height="65"
                    width="90"
                    flat
                    outlined
                    class="mr-2 mt-3"
                >
                    <v-card-title
                        class="pb-0 pt-0 d-flex justify-center"
                        style="font-size:0.7rem"
                    >
                        Average
                    </v-card-title>
                    <v-card-text
                        class="text-center pb-0 text-h6 font-weight-bold px-0 primary--text"                        
                    >
                        <span :style="styleFontSize">{{ getStudentAverage }} </span>
                    </v-card-text>
                </v-card>
    
                <v-card
                    height="65"
                    width="90"
                    flat
                    outlined
                    class="mt-3"
                >
                    <v-card-title
                        class="pb-0 pt-0 d-flex justify-center"
                        style="font-size:0.7rem"
                    >
                        Grade
                    </v-card-title>
                    <v-card-text
                        class="text-center pb-0 text-h6 font-weight-bold px-0 primary--text"                        
                    >
                        <span :style="styleFontSize">{{ grade }} </span>
                    </v-card-text>
                </v-card>
    
                <v-card
                    flat
                    class="ml-4"
                >
                    <v-row 
                        class="pl-0 ml-0 mb-0"
                    >
                        
                        <v-card 
                            width="80" 
                            flat
                            class="ml-auto mr-3"
                            style="font-size:0.55rem; text-align: center"
                        >
                            All Classes
                        </v-card>
                        <v-card 
                            width="75" 
                            flat 
                            style="font-size:0.55rem"                           
                        >
                            Current Class
                        </v-card>                       
                    </v-row>
    
                    <v-row class="pl-0 ml-0 mb-2 mt-0">
                        <v-card 
                            flat 
                            style="font-size:0.7rem"
                            class="mr-2"
                            width="82"
                        >
                            Possible Att.
                        </v-card>
                        <v-card 
                            width="80" 
                            flat
                            class="mr-2"
                        >
                            <v-text-field                                
                                v-model="possibleAttendanceAll"
                                outlined
                                hide-details
                                dense
                                style="font-size:0.7rem"
                                type="number"
                                @blur="changePossibleAttendance('All')"
                                :disabled="!admin"
                            ></v-text-field>
                        </v-card>
                        <v-card 
                            width="80" 
                            flat                            
                        >
                            <v-text-field
                                v-model="studentRecord.possible_attendance"
                                outlined
                                hide-details
                                dense
                                style="font-size:0.7rem"
                                type="number"
                                @blur="changePossibleAttendance(studentRecord.class_id)"
                                :disabled="!admin"
                            ></v-text-field>
                        </v-card>                       
                    </v-row>
    
                    <v-row class="pl-0 ml-0 mb-2">
                        <v-card 
                            flat 
                            style="font-size:0.7rem"
                            class="mr-2"
                            width="82"
                        >
                            School Reopens
                        </v-card>
                        <v-card 
                            width="80" 
                            flat
                            class="mr-2"
                        >                            
                            <date-picker 
                                v-on:change-date="newTermDate($event,'All')"
                                :disabled="!admin"                                
                            ></date-picker>                           
                        </v-card>
                        <v-card 
                            width="80"
                            style="font-size:0.7rem" 
                            flat                            
                        >
                            <date-picker 
                                v-on:change-date="newTermDate($event, studentRecord.class_id)"
                                v-bind:date="studentRecord.new_term_beginning"
                                :disabled="!admin"
                            ></date-picker> 
                        </v-card>                       
                    </v-row>
    
                    <v-row class="pl-0 ml-0">
                        <v-card 
                            flat 
                            style="font-size:0.7rem"
                            class="mr-2"
                            width="82"
                        >
                            Change Class
                        </v-card>
                        <v-card 
                            width="80" 
                            flat
                            class="mr-2"
                        >
                            <v-select
                                outlined
                                hide-details
                                dense
                                :items="classes"
                                class="change-class"
                                style="font-size:0.6rem"
                                v-model="studentRecord.class_id"
                                @change="changeClass"
                                :disabled="!admin"
                            ></v-select>
                        </v-card>
                        <v-card 
                            width="80" 
                            flat                            
                        >
                            <v-btn                                
                                color="primary"
                                x-small
                                height="30"
                                block
                                @click="deleteRecord"
                                :disabled="!admin"                                
                            >
                                Delete
                            </v-btn>
                        </v-card>                       
                    </v-row>
                                    
            
                </v-card>
            </v-card>
        </div>
        
       <!-- More Options -->
        <v-dialog v-model="dialog" persistent width="300">
            <v-card>
                <v-card-title class="text-h6 grey lighten-2">
                    More Options
                </v-card-title>

                <v-btn
                    dark
                    color="error"
                    x-small
                    fab
                    style="position:absolute; top:10px; right:10px; z-index:100"
                    @click="dialog = !dialog"
                >
                    <v-icon dark>mdi-close</v-icon>
                </v-btn>


                <v-container>
                    <div class="mt-4">            
                        <v-card flat  class="">
                            <!-- <v-col class="pa-0 mr-4 flex-grow-0">
                                <v-card
                                    height="89"
                                    width="90"
                                    flat
                                    outlined
                                    class="ml-3"
                                >
                                    <v-card-title
                                        class="pb-0 d-flex justify-center"
                                        style="font-size:0.7rem"
                                    >
                                        Average
                                    </v-card-title>
                                    <v-card-text
                                        class="text-center text-h6 font-weight-bold px-0 primary--text"                        
                                    >
                                        <span :style="styleFontSize">{{ getStudentAverage }} </span>
                                    </v-card-text>
                                </v-card>
                            </v-col> -->
            
                            <v-col class="pa-0 flex-grow-0">
                                <v-card
                                    flat
                                >
                                    <v-row 
                                        class="pl-3 ml-0 mb-1"
                                    >
                                        
                                        <v-card 
                                            width="80" 
                                            flat
                                            class="ml-auto mr-3"
                                            style="font-size:0.55rem; text-align: center"
                                        >
                                            All Classes
                                        </v-card>
                                        <v-card 
                                            width="75" 
                                            flat 
                                            style="font-size:0.55rem"                           
                                        >
                                            Current Class
                                        </v-card>                       
                                    </v-row>
            
                                    <v-row class="pl-3 ml-0 mb-2">
                                        <v-card 
                                            flat 
                                            style="font-size:0.7rem"
                                            class="mr-2"
                                            width="82"
                                        >
                                            Possible Att.
                                        </v-card>
                                        <v-card 
                                            width="80" 
                                            flat
                                            class="mr-2"
                                        >
                                            <v-text-field                                
                                                v-model="possibleAttendanceAll"
                                                outlined
                                                hide-details
                                                dense
                                                style="font-size:0.7rem"
                                                type="number"
                                                @blur="changePossibleAttendance('All')"
                                                :disabled="!admin"
                                            ></v-text-field>
                                        </v-card>
                                        <v-card 
                                            width="80" 
                                            flat                            
                                        >
                                            <v-text-field
                                                v-model="studentRecord.possible_attendance"
                                                outlined
                                                hide-details
                                                dense
                                                style="font-size:0.7rem"
                                                type="number"
                                                @blur="changePossibleAttendance(studentRecord.class_id)"
                                                :disabled="!admin"
                                            ></v-text-field>
                                        </v-card>                       
                                    </v-row>
            
                                    <v-row class="pl-3 ml-0 mb-2">
                                        <v-card 
                                            flat 
                                            style="font-size:0.7rem"
                                            class="mr-2"
                                            width="82"
                                        >
                                            School Reopens
                                        </v-card>
                                        <v-card 
                                            width="80" 
                                            flat
                                            class="mr-2"
                                        >                            
                                            <date-picker 
                                                v-on:change-date="newTermDate($event,'All')"
                                                :disabled="!admin"                                
                                            ></date-picker>                           
                                        </v-card>
                                        <v-card 
                                            width="80"
                                            style="font-size:0.7rem" 
                                            flat                            
                                        >
                                            <date-picker 
                                                v-on:change-date="newTermDate($event, studentRecord.class_id)"
                                                v-bind:date="studentRecord.new_term_beginning"
                                                :disabled="!admin"
                                            ></date-picker> 
                                        </v-card>                       
                                    </v-row>
            
                                    <v-row class="pl-3 ml-0">
                                        <v-card 
                                            flat 
                                            style="font-size:0.7rem"
                                            class="mr-2"
                                            width="82"
                                        >
                                            Change Class
                                        </v-card>
                                        <v-card 
                                            width="80" 
                                            flat
                                            class="mr-2"
                                        >
                                            <v-select
                                                outlined
                                                hide-details
                                                dense
                                                :items="classes"
                                                class="change-class"
                                                style="font-size:0.6rem"
                                                v-model="studentRecord.class_id"
                                                @change="changeClass"
                                                :disabled="!admin"
                                            ></v-select>
                                        </v-card>
                                        <v-card 
                                            width="80" 
                                            flat                            
                                        >
                                            <v-btn                                
                                                color="primary"
                                                x-small
                                                height="30"
                                                block
                                                @click="deleteRecord"
                                                :disabled="!admin"                                
                                            >
                                                Delete
                                            </v-btn>
                                        </v-card>                       
                                    </v-row>
                                    
            
                                </v-card>
                            </v-col>

                        </v-card>
                    </div>
                </v-container>
                <v-card-actions class="mt-6 justify-space-between">
                    <v-btn small depressed @click="dialog = !dialog">Close Options</v-btn>
                    <v-btn small color="primary">Update Options</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>


        <!-- Search for Student Record -->
        <v-overlay
            absolute
            :value="overlaySearch"
            color="secondary"
            opacity="0.6"
        >
            <v-expand-transition>
                <v-card
                    max-width="600"
                    class="mx-auto pa-6"
                    transition="scroll-y-transition"
                    v-show="expand"
                    light
                >
                    <v-card-title
                        class="mb-6"
                    >
                        <v-text-field
                            v-model="search"
                            label="Search for Student Record"
                            append-icon="mdi-magnify"
                            class="mx-4"
                            hide-details
                            single-line
                            clearable
                        ></v-text-field>
                    </v-card-title>
                    <v-data-table
                        :headers="headersStudents"
                        :items="table1Records"
                        :search="search"
                        fixed-header
                        height="40vh"
                        :options="options"
                        dense
                    >
                        <template
                            v-slot:[`item.actions`]="{ item }"
                        >
                            <v-btn
                                text
                                color="primary"
                                @click="viewRecord(item)"
                            >
                                View Record
                            </v-btn>
                        </template>
                    </v-data-table>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            text
                            color="primary"
                            outlined
                            @click="cancelSearch"
                        >
                            Cancel Search
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-expand-transition>
        </v-overlay>        
    </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import DatePicker from './DatePicker.vue';
import SubjectRow from './EditViewTermReportsSubjectRow';
export default {
    components: {        
        DatePicker,
        SubjectRow,
    },
        
    data: () => ({
        headers: [],
        headersSubjects:[],
        headersStudents: [
            { text: 'Student ID', align: 'center', value: 'student_id', width: '75' },
            { text: 'First Name', align: 'left', value: 'first_name', width: '100' },
            { text: 'Last Name', align: 'left', value: 'last_name', width: '100' },
            { text: '', align: 'center', value: 'actions', sortable: false, width: '150' },
        ],
        subjectRecords: [],        
        studentAverage: '',
        studentPasses: null,
        studentDistinctions: '-',
        imageSrc: null,        
        value: ' ', 
        rules: [],
        isValid: true, 
        record: {},
        subjectRecord: [],
        disabled: true,
        displayAverage: false,
        displayGrade: false,
        displayPasses: false,
        displayDistinctions: false,
        formLevel: null,
        btnClass: 'text-caption pa-2  white--text',
        codedComment: null,
        styleFontSize: '0.7rem',
        classes: [],
        newTermBeginningAll: '', 
        overlaySearch: false, 
        expand: false, 
        search: null,  
        options: {
            itemsPerPage: -1,
        },
        possibleAttendanceAll: null,
        dialog: false,
        maxCourse: 100,
        maxExam: 100,
        grades1: [
            { grade: 'A', min: 85},
            { grade: 'B', min: 75},
            { grade: 'C', min: 65},
            { grade: 'D', min: 55},
            { grade: 'E', min: 45},
            { grade: 'F', min: 0},
        ],
        grades2: [
            { grade: 'I', min: 85},
            { grade: 'II', min: 75},
            { grade: 'III', min: 65},
            { grade: 'IV', min: 55},
            { grade: 'V', min: 45},
            { grade: 'VI', min: 0},
        ]                      
    }),

    watch: {       
        table2Records: {
            deep: true,
            handler () {                                           
                this.getAverage();
                this.setTableHeaders();
            }
        },

        studentRecord: {
            handler(val){ 
                this.initialize();               
                this.formLevel = val.form_level;
                if(
                    this.formTeacherClass.indexOf(this.studentRecord.class_id) === -1 && 
                    !this.admin &&
                    this.deanFormClasses.indexOf(this.studentRecord.class_id) === -1
                ){
                    //console.log('Not the form Teacher');
                    this.disabled = true;
                }
                else{
                    //console.log('Assigned Form Teacher');
                    this.disabled = false;
                }
                //this.setTableHeaders();
                //console.log(this.selectedFormClass);
            }
        },
        
        formClasses: {
            handler () {
                //this.setFormClasses();
            }
        }
    },

    computed: {
        ...mapGetters({
            sheet: 'termReports/getCommentSheet',
            formTeacherComments: 'termReports/getFormTeacherComments',
            table2Records: 'termReports/getEditViewTermReportsTable2Records',            
            studentRecord: 'termReports/getSelectedStudentRecord',
            formTeacherClass: 'termReports/getFormTeacherClass',
            formClasses: 'termReports/getFormClasses',
            currentTerm: 'termReports/getCurrentTerm',
            currentYear: 'termReports/getCurrentYear',
            pagination: 'termReports/getPagination',
            selectedFormClass: 'termReports/getSelectedFormClass',
            table1Records: 'termReports/getTable1Records',
            studentSubjects: 'termReports/getEditViewTermReportsStudentSubjects',
            admin: 'auth/getAdmin',
            menuOptions: 'admin/getMenuOptions',
            subjectWeightings: 'termReports/getSubjectWeightings',
            deanFormClasses: 'termReports/getDeanFormClasses', 
            editTermReports: 'admin/getEditTermReports', 
            selectedFormLevel: 'termReports/getSelectedFormLevel',
        }),       

        getStudentAverage () {
            return isNaN(this.studentAverage) ? this.studentAverage : this.studentAverage + ' %';
        },

        grade (){
            if(isNaN(this.studentAverage)) return null;
            return this.grades1.find(grade => grade.min <= this.studentAverage).grade;
            // if(this.studentRecord.form_level <= 4){
            // }
            // else{
            //     return this.grades2.find(grade => grade.min <= this.studentAverage).grade;
            // }
        }
        
        
    },
    methods: {
        ...mapMutations({
            setCommentSheet: 'termReports/setCommentSheet',
            setSaveStatus: 'termReports/setEditViewTermReportsSaveStatus',
            setSaving: 'termReports/setEditViewTermReportsSaving',
            setSaveError: 'termReports/setEditViewTermReportsSaveError',
            setSaved: 'termReports/setEditViewTermReportsSaved',
            setPagination: 'termReports/setPagination',
            overlay: 'termReports/setEditViewTermReportsOverlay',
            loading: 'termReports/setEditViewTermReportsLoading',
            setSelectedStudentRecord: 'termReports/setSelectedStudentRecord',
            setTable2Records: 'termReports/setEditViewTermReportsTable2Records',
            setBottomSheetModel: 'termReports/setBottomSheetModel',
            setBottomSheetTitle: 'termReports/setBottomSheetTitle',
            setChangeClassRecord: 'admin/setChangeClassRecord',            
            setSnackbar: 'admin/setSnackbar',
            setPossibleAttendance: 'admin/setPossibleAttendance',
            setNewTermBeginning: 'admin/setNewTermBeginning',
            setDialogDelete: 'admin/setDialogDelete',
            setSelectedTable1Record: 'admin/setSelectedTable1Record',
            setExpandTerms: 'termReports/setExpandTerms',
            setSrc: 'termReports/setSrc',
            setEnterMarks: 'termReports/setEnterMarks',
            setEditViewTermReports: 'termReports/setEditViewTermReports',
            setMarkSheetOverlay: 'termReports/setMarkSheetOverlay',            
            setMarkSheetLoading: 'termReports/setMarkSheetLoading',
            setOverlay: 'termReports/setEditViewTermReportsOverlay',
            setExpand: 'termReports/setEditViewTermReportsExpand', 
            setLoading: 'termReports/setEditViewTermReportsLoading', 
            setStudentSubjects: 'termReports/setEditViewTermReportsStudentSubjects', 
            setTable1Records: 'termReports/setTable1Records',
        }),

        ...mapActions({
            postTable1Record: 'termReports/postTable1Record',
            getTable1Record: 'termReports/getTable1Record',
            setErrorResponse: 'termReports/setErrorResponse',
            getTable2Records: 'termReports/getTable2Records',
            postChangeClass: 'admin/changeClass',
            postPossibleAttendance: 'admin/postPossibleAttendance',
            postNewTermBeginning: 'admin/postNewTermBeginning',
            getFormClasses: 'termReports/getClassesChangeClass',
            downloadAcademicHistory: 'termReports/downloadAcademicHistory',
        }),

        async initialize () {
            try {
                const { data } = await this.getFormClasses();
                this.setFormClasses(data);
            } catch (error) {   
                error.response ? console.log(error.response) : console.log(error);
            }
        },

        setFormClasses (data) {            
            data.forEach(value => {
                this.classes.push(value.id);
            });
        },

       getAverage(){
            this.styleFontSize = null;                   
            let recordCount = 0; 
            let totalCourseMark = 0;
            let totalExamMark = 0;
            this.table2Records.forEach(record => {
                recordCount++; 
                totalCourseMark += record.course_mark;
                totalExamMark += record.exam_mark;
            })
            
            //console.log(`Total: ${totalMarks}`);
            if(recordCount != 0 ){ 
                              
                // this.studentAverage =  Math.round(((totalCourseMark/recordCount)*0.3 + (totalExamMark/recordCount)*0.7)*10) / 10;
                const studentAverage =  (totalCourseMark/recordCount)*0.3 + (totalExamMark/recordCount)*0.7;
                const roundedAverage = Number(studentAverage.toFixed(2));
                this.studentAverage = roundedAverage.toPrecision(3);
            }
            else if(recordCount == 0) this.studentAverage = '--';
           
            
        },
        
        saveTeacherComment(){
            this.updateRecord();
        },

        openBottomSheet(model){
            this.setBottomSheetModel(model); 
            if(model == 'comments'){
                this.setBottomSheetTitle('Form Teacher Comments');
            }
            else{
                this.setBottomSheetTitle('General Remarks: Conduct');
            }
            if(!this.disabled) this.setCommentSheet(true);
        },

        async updateRecord(){
            console.log('updating...');
            this.setSaveStatus('Saving...');
            this.setSaving(true);
            this.setSaved(false);
            this.setSaveError(false);
            //this.studentRecord.lib_comment = this.codedComment.id;           
            //console.log(this.studentRecord);
            try{
                await this.postTable1Record();
                this.setSaveStatus('Record Saved');
                this.setSaving(false);
                this.setSaved(true);
                this.setSaveError(false);
                //console.log(response);
            } catch (error) {
                console.log(error);
                this.setSaveStatus('Error Occured');
                this.setSaving(false);
                this.setSaved(false);
                this.setSaveError(true);
                this.setErrorResponse(error);
            }            
        },

        setTableHeaders () {
            this.headers = [
                {text: 'Code', align: 'center', value: 'subject_id', width: '60', sortable: false},
                {text: 'Subject', align: 'start', value: 'abbr', width: '90', sortable: false},
                {text: 'Mid Term Exam', align: 'center', value: 'course_mark', width: '80', sortable: false},
                {text: 'Grade', align: 'start', value: 'con1', width: '70', sortable: false},
                {text: 'End of Term Exam', align: 'start', value: 'exam_mark', width: '80', sortable: false},
                {text: 'Grade', align: 'start', value: 'app1', width: '70', sortable: false},
                {text: 'Comment1', align: 'start', value: 'coded_comment', width: '80', sortable: false},
                {text: 'Comment2', align: 'start', value: 'coded_comment_1', width: '80', sortable: false},               
                {text: '', align: 'start', value: 'actions', sortable: false}               
            ];                    

            this.headersSubjects = [{text: "Subjects\n\t", value: 'abbr', sortable:false}]
             
        },

        async changeClass () {
            this.overlay(true);
            this.loading(true);            
            this.setChangeClassRecord({
                student_id: this.studentRecord.student_id,
                class_id: this.studentRecord.class_id
            })
            try {
                await this.postChangeClass();
                this.setSnackbar({
                    text: `Class changed to ${this.studentRecord.class_id}`,
                    display: true,
                    color: 'primary',
                });               
            } catch (error) {
                if(error.response) console.log(error.response);
                else console.log(error);
                this.setSnackbar({
                    text: `Error occured`,
                    display: true,
                    color: 'red',
                });              
            }            
            this.overlay(false);
            this.loading(false);
        },

        async changePossibleAttendance (formClass) {
            this.loading(true);

            let snackbar = {};

            if(formClass == 'All'){
                this.studentRecord.possible_attendance = this.possibleAttendanceAll;
                this.setPossibleAttendance({
                    possible_attendance: this.possibleAttendanceAll,
                    class_id: null,
                    year: this.studentRecord.year,
                    term: this.studentRecord.term,
                });
                snackbar.text = `Possible attendance set to ${this.possibleAttendanceAll} for all classes.`
                
            }
            else{
                this.setPossibleAttendance({
                    possible_attendance: this.studentRecord.possible_attendance,
                    class_id: this.studentRecord.class_id,
                    year: this.studentRecord.year,
                    term: this.studentRecord.term,
                })
                snackbar.text = `Possible attendance set to ${this.studentRecord.possible_attendance} for ${this.studentRecord.class_id}.`
            }

            try {
                await this.postPossibleAttendance();
                this.updateTable1Record();
                snackbar.color = 'primary';
                snackbar.display = true;
                this.setSnackbar(snackbar);  
            } catch (error) {
                if(error.response) console.log(error.response);
                else console.log(error);
                snackbar.color= 'red';
                snackbar.display = true;
                snackbar.text = 'An Error Has Occured';
                this.setSnackbar(snackbar);
            }
            
            this.overlay(false);
            this.loading(false);
        },

        async updateTable1Record () {
            const { data } = await this.getTable1Record();
            this.setTable1Records(data.data);
        },

        async newTermDate (e, formClass) {
            this.overlay(true);
            this.loading(true);
            this.studentRecord.new_term_beginning = e;

            let snackbar = {};

            if(formClass == 'All'){
                this.setNewTermBeginning({
                    new_term_beginning: e,
                    class_id: null,
                    year: this.studentRecord.year,
                    term: this.studentRecord.term,
                });
                snackbar.text = `New Term Beginning set to ${e} for all classes.`
            }
            else{
                this.setNewTermBeginning({
                    new_term_beginning: e,
                    class_id: this.studentRecord.class_id,
                    year: this.studentRecord.year,
                    term: this.studentRecord.term,
                });
                snackbar.text = `New Term Beginning set to ${e} for ${formClass}.`
            }
            // console.log(`Date: ${e}, class: ${formClass}`);

            try {
                await this.postNewTermBeginning();
                snackbar.color = 'primary';
                snackbar.display = true;
                this.setSnackbar(snackbar);  
            } catch (error) {
                if(error.response) console.log(error.response);
                else console.log(error);
                snackbar.color= 'red';
                snackbar.display = true;
                snackbar.text = 'An Error Has Occured';
            }

            this.overlay(false);
            this.loading(false);
            
        },

        deleteRecord () {
            // console.log(this.table2Records);
            this.setSelectedTable1Record(this.studentRecord);
            if(this.table2Records.length != 0){
                this.setDialogDelete({
                    display: true,
                    text: 'Cannot delete record with existing subject records. Please delete all subject records first.',
                    cancel: false,
                    deleteSubject: false,
                    deleteStudent: false,
                    ok: true
                })
            }
            else{
                this.setDialogDelete({
                    display: true,
                    text: `Delete ${this.studentRecord.first_name} ${this.studentRecord.last_name} ?`,
                    cancel: true,
                    deleteSubject: false,
                    deleteStudent: true,
                    ok: false
                })
            }
        },

        classMarkSheet () {
            this.overlay(true);
            this.$nextTick(() => {
                this.setExpandTerms(true);
            });

            this.setSrc({
                baseUrl: process.env.VUE_APP_API_URI  + '/api/mark-sheet',
                year: this.currentYear,
                term: this.currentTerm,
                classId: this.studentRecord.class_id,
                report: 'mark-sheet'               
            });

        },

        rankSheet () {            
            this.overlay(true);
            this.$nextTick(() => {
                this.setExpandTerms(true);
            });
            
            this.setSrc({
                baseUrl: process.env.VUE_APP_API_URI  + '/api/rank-sheet',
                year: this.currentYear,
                term: this.currentTerm,
                classId: this.studentRecord.class_id,
                report: 'rank-sheet'               
            });           
           
        },
        
        classStudentSubjects (item) {
            // console.log(item);            
            if(item.entered == 1) return "font-weight-bold primary--text";
            return "font-weight-bold red--text";
        },

        enterMarks () {
            if(this.admin){
                 Object.keys(this.menuOptions).forEach(key => {
                    this.menuOptions[key] = false;
                })
                this.menuOptions["enterMarks"] = true;
            }
            else{                
                this.setEnterMarks(true);
                this.setEditViewTermReports(false);
                this.setMarkSheetOverlay(true);                    
                this.setMarkSheetLoading(true); 
            }
        },

        displayReportCard () {
            this.overlay(true);
            
            this.$nextTick(() => {
                this.setExpandTerms(true);
            });
            
            this.setSrc({
                baseUrl: process.env.VUE_APP_API_URI  + '/api/report-card',
                studentId: this.studentRecord.student_id,
                year: this.studentRecord.year,
                term: this.studentRecord.term,
                report: 'report-card'               
            });  
        },

        displayReportCardsClass () {
            this.overlay(true);

            this.$nextTick(() => {
                this.setExpandTerms(true);
            });
            
            this.setSrc({
                baseUrl: process.env.VUE_APP_API_URI  + '/api/report-card',
                studentId: this.studentRecord.student_id,
                year: this.studentRecord.year,
                term: this.studentRecord.term,
                report: 'report-card',
                classId: this.studentRecord.class_id,               
            });  
        },

        nextClass () {
            this.setOverlay(true);
            this.setExpand(true);
        },

        searchStudent(){
            this.overlaySearch = true;
            setTimeout(() => {
                this.expand = true;
            })
        },

        cancelSearch(){
            this.expand = false;
            setTimeout(() => {
                this.overlaySearch = false;
            }, 600);
        },

        viewRecord(item){
            //console.log(item);
            this.expand = false;
            setTimeout(() => {
                this.overlaySearch = false;
            }, 600);
            let recordIndex = this.table1Records.indexOf(item);
            this.recordNavigation(++recordIndex);
        },

        async recordNavigation(pagination){
            this.setOverlay(true);
            this.setLoading(true);
            
            this.makePagination(pagination);
            this.setSelectedStudentRecord(this.table1Records[--pagination]);
            try {
                const { data: { table2_records, student_subjects } } = await this.getTable2Records();
                this.setTable2Records(table2_records);
                this.setStudentSubjects(student_subjects);
            } catch (error) {
                if(error.response) console.log(error.response);
                else console.log(error);
            }            
            this.setOverlay(false);
            this.setLoading(false);           
        },

        makePagination(data){
            let prev_page = data;
            let current_page = data;
            let next_page = (current_page === this.pagination.last_page) ? null : ++data;
            prev_page = (current_page === 1) ? null : --prev_page;
            
            let pagination = {
                current_page: current_page,
                last_page: this.pagination.last_page,
                next_page: next_page,
                prev_page: prev_page,
            };
            this.setPagination(pagination);
        },

        closeEditViewTermReports () {
            this.setOverlay(true);
            this.setExpand(true);
        },

        showMoreOptions () {
            this.dialog = true;
        },

        displayAcademicHistory () {
            this.overlay(true);
            
            this.setSrc({
                baseUrl: process.env.VUE_APP_API_URI  + '/api/academic-history',
                student_id: this.studentRecord.student_id,
                report: 'academic-history',               
            });

            this.setLoading(true);
            this.setOverlay(true);
            let fileName = this.studentRecord.student_id + ' Academic History.xlsx';

            this.downloadAcademicHistory()
            .then(response => {
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(
                    new Blob([response.data])
                );
                link.setAttribute('download', fileName);
               
                document.body.appendChild(link);
                link.click();
                       
            })
            .catch( error => {
                error.response ? console.log(error.response) : console.log(error);
                this.snackbar.text = 'Error Occured. Could not download file.';
                this.snackbar.color = 'red';
                this.snackbar.display = true;
                
            })
            setTimeout(() => {
                this.setOverlay(false);
                this.setLoading(false);
            }, 600)
        },



    }
}
</script>

<style scoped>    

    ::v-deep .v-input__slot{
        min-height: 0px !important;
        display: flex !important;
        align-items: center !important;
    }

    .v-btn__content{
        font-size: 0.8em;
    }

    ::v-deep .v-input__append-inner{
        margin-top: 0;
    }

    ::v-deep .v-select__selections{
        height: 30px;
        /*padding: 0 !important;*/
        padding-top: 2px !important;
        padding-bottom: 2px !important;
    }

    ::v-deep .v-text-field__slot input{
        text-align: center;
    }

    ::v-deep .v-text-field__slot textarea{
        line-height: 1rem;
        font-size: 0.7rem;
    }

    ::v-deep .v-data-table > .v-data-table__wrapper > table > thead > tr > th {
        padding: 0 6px;
        font-size: 0.7rem;
        text-align: center;
    }

    ::v-deep .v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
        padding: 0 6px;
        font-size: 0.75rem;
    }

    ::v-deep .v-data-table--dense > .v-data-table__wrapper > table > tbody > tr > td {
        height: 22px;
    }

    ::v-deep .v-data-table--dense > .v-data-table__wrapper > table > thead > tr > th {
        height: 22px;
    }

    ::v-deep textarea {
        padding-top: 8px;
    }

    ::v-deep .v-input input{
        height: 25px;
    }

    /* ::v-deep .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded) > .v-input__control > .v-input__slot, .v-text-field.v-text-field--enclosed .v-text-field__details{
        padding: 0 5px;
    } */

    ::v-deep .change-class .v-input__icon{
        min-width: 10px;
        width: 10px;
    }

    ::v-deep .v-list-item__title{
        min-width: 100px;
    }

    ::v-deep .v-select.v-input--dense .v-select__selection--comma{
        width: 50px;
        text-align: center;
    }

    ::v-deep .v-textarea.v-text-field--enclosed textarea{
        margin-top: 5px;
    }

    ::v-deep #label-form-class{
        position: absolute;
        top: -15px;
        right: 0;
    }

    ::v-deep .v-text-field--filled .v-label--active {
        transform: translateY(-20px) scale(0.75);
    }

    /* Chrome, Safari, Edge, Opera */
    ::v-deep input::-webkit-outer-spin-button,
    ::v-deep input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
    text-align:center
    }

    /* Firefox */
    ::v-deep input[type=number] {
    -moz-appearance: textfield;
    appearance: textfield;
    text-align: center;
    }

    ::v-deep th span{
        white-space: pre-wrap;
        text-align: center;
        display: flex;
    }
</style>